import React from "react";

import Editor from './AHardcoverEditor'
import EditorWrapper from '../../EditorWrapper'

import HardcoverTile from "../../common/HardcoverTile";
import { HardcoverArticle } from "../../common/EmptyArticle";

const AHardcoverTile = props => {
    const article = HardcoverArticle();
    const { settings } = props;
    article.tracking_code = settings.tracking_code

    return (
        <div className={props.classes} {...props.events} >
            <EditorWrapper {...props} editor={Editor} />
            <HardcoverTile article={article} size={props.size} imageHeight={props.imageHeight} preserveImageRatio={props.preserveImageRatio} />
        </div>
    );
};

export default AHardcoverTile;
